import React, { useState, useEffect } from 'react';
import SectionTitle from '../templates/SectionTitle';
import ReceiptHistoryItem from '../templates/ReceiptHistoryItem';
import { btsApi } from '../services/btsApi';
import BtsTermsBox from '../templates/BtsTermsBox';
import { historyTerms } from '../data/mockData';
import './HistoryPage.css';
const IS_PROD = process.env.REACT_APP_ENV === 'prod';
const log = (...args) => { if (!IS_PROD) console.log(...args); };

const HistoryPage = ({ showPopup }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        log('[BTS History] Fetching receipt history...');
        const res = await btsApi.getReceiptHistory();
        log('[BTS History] Result:', res);

        const items = (res?.data || []).map((r, i) => ({
          id: r.id || i,
          txCode: (r.qr_code || '').split('_')[1] || `TX-${r.id}`,
          date: r.sale_date
            ? new Date(r.sale_date).toLocaleDateString('th-TH', { day: 'numeric', month: 'short', year: 'numeric' })
            : r.scanned_at
            ? new Date(r.scanned_at).toLocaleDateString('th-TH', { day: 'numeric', month: 'short', year: 'numeric' })
            : '-',
          time: r.scanned_at ? new Date(r.scanned_at).toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' }) : '',
          amount: `฿${Math.floor(r.total_amount || 0).toLocaleString()}`,
          points: Math.floor(r.calculated_tickets || 0),
          multiplier: r.multiplier || 1,
          isNewMember: r.is_new_member || false,
          partnerId: r.partner_id || null,
          storeName: r.store_name || null,
          reconcileStatus: r.reconcile_status || null,
          revertedTickets: r.reverted_tickets || 0,
          clmStatus: r.clm_status || null,
        }));
        setHistory(items);
      } catch (err) {
        console.error('[BTS History] Error:', err);
        if (showPopup) showPopup('เกิดข้อผิดพลาด', 'ไม่สามารถโหลดประวัติได้');
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, [showPopup]);

  const totalPoints = history.reduce((sum, item) => {
    const isCancelled = item.reconcileStatus === 'RETURNED' || item.reconcileStatus === 'CANCELLED';
    return sum + (isCancelled ? 0 : (item.points || 0));
  }, 0);

  return (
    <div>
      <SectionTitle icon="📋">ประวัติบิลสะสมของท่าน</SectionTitle>

      {loading ? (
        <div className="bts-history__loading">กำลังโหลด...</div>
      ) : (
        <>
          <div className="bts-history__summary">
            <div className="bts-history__stat">
              <p className="bts-history__stat-label">รวมสแกน</p>
              <p className="bts-history__stat-value">{history.length} บิล</p>
            </div>
            <div className="bts-history__divider" />
            <div className="bts-history__stat">
              <p className="bts-history__stat-label">คะแนนรวม</p>
              <p className="bts-history__stat-value bts-history__stat-value--green">
                {totalPoints.toLocaleString()}
              </p>
            </div>
          </div>

          {history.length === 0 ? (
            <div className="bts-history__empty">
              <span className="bts-history__empty-icon">🧾</span>
              <p className="bts-history__empty-title">ยังไม่มีประวัติการสแกน</p>
              <p className="bts-history__empty-desc">สแกน QR Code บนใบเสร็จ Big C เพื่อสะสมคะแนน!</p>
            </div>
          ) : (
            history.map((item) => (
              <ReceiptHistoryItem key={item.id} item={item} />
            ))
          )}
        </>
      )}

      <BtsTermsBox title="เงื่อนไข : การสะสมยอดคะแนน" terms={historyTerms} />

      <div className="bts-history__spacer" />
    </div>
  );
};

export default HistoryPage;
